var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.989 14.14V9.906c0-2.515-1.98-4.572-4.4-4.572h-5.867c-1.13 0-2.156.457-2.933 1.189-.778-.732-1.804-1.189-2.934-1.189H7.99c-2.42 0-4.4 2.057-4.4 4.572v4.236a4.629 4.629 0 00-1.467 3.383v9.143h2.933v-3.048h23.467v3.048h2.933v-9.143a4.628 4.628 0 00-1.466-3.383zM19.722 8.38h5.867c.806 0 1.466.687 1.466 1.525v3.047h-8.8V9.905c0-.838.66-1.524 1.467-1.524zm-13.2 1.525c0-.838.66-1.524 1.467-1.524h5.866c.807 0 1.467.686 1.467 1.524v3.047h-8.8V9.905zM5.055 20.57v-3.047c0-.838.66-1.524 1.467-1.524h20.533c.807 0 1.467.686 1.467 1.524v3.047H5.055z",
    fill: "#2C5BFF"
  })));
}
export default __webpack_public_path__ + "media/propertyTour/bedroom-86e69f3e.svg";
export { SvgBedroom as ReactComponent };